import { Grid, FormControlLabel, Checkbox } from '@mui/material';

const TabThirteen = ({
  setDesignations,
  designations,
  onClickAll,
  isEdit
}) => {
  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          id="designations-form-all"
          control={
            <Checkbox
              id="designations-all"
              checked={designations.every((designation) => designation.value)}
              onClick={(e) => onClickAll(designations, 'common', setDesignations, e)}
              disabled={isEdit}
            />
          }
          label="All"
        />
      </Grid>
      <Grid item xs={4}>
        {designations.map(
          (data, index) =>
            data.name === 'Create Designation' && (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={designations[index]?.value}
                    onChange={(e) => {
                      let items = [...designations];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setDesignations(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {designations.map(
          (data, index) =>
            data.name === 'View Designations' && (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={designations[index]?.value}
                    onChange={(e) => {
                      let items = [...designations];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setDesignations(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {designations.map(
          (data, index) =>
            data.name === 'Edit Designation' && (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={designations[index]?.value}
                    onChange={(e) => {
                      let items = [...designations];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setDesignations(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
    </Grid>
  );
};

export default TabThirteen;